import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileText, Loader2 } from "lucide-react";

// Admin-only, no-shell cover-sheet backfill (idempotent).
export function CoverBackfillButton() {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/cover-letters/backfill", {});
      setResult(data);
      toast.success(`Cover sheets backfilled: ${data.covered}/${data.eligible}`);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Backfill failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="cover-backfill" className="rounded-xl border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="font-semibold text-slate-900">Provider cover sheets</p>
          <p className="text-xs text-slate-500">Generate/refresh the cover sheet for every assigned, open order. Idempotent — safe to run anytime.</p>
        </div>
        <Button data-testid="cover-backfill-btn" size="sm" variant="outline" disabled={busy} onClick={run}>
          {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <FileText className="mr-1 h-4 w-4" />} Run cover sheet backfill
        </Button>
      </div>
      {result && (
        <div data-testid="cover-backfill-result" className="mt-3 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800">
          <p className="font-semibold">Covered {result.covered}/{result.eligible} order(s) · failed {result.failed}</p>
          <p className="text-xs">AR-33099: {result.ar_33099}</p>
          {result.failed > 0 && <p className="mt-1 text-xs text-red-600">Failed: {(result.failed_jobs || []).join(", ")}</p>}
        </div>
      )}
    </div>
  );
}
